require('./news-item.less');

jQuery(function() {
    $('.js-news-item-img').click(function(e) {
        e.preventDefault();
        var $newsItem = $(this).closest('.news-item');
        var $newsItemLink = $newsItem.find('.news-item__link');

        window.location = $newsItemLink.attr('href');
    });
});



// WEBPACK FOOTER //
// ./blocks/news-item/news-item.js